/* =========================================================
   BBX — PDP Media Modal (PORTAL + Swipe + Zoom) — FAST / NO SCROLL LOGIC
   ✅ NO scrollTo, NO anchors, NO scrollRestoration
   ✅ "VER DESCRIPCIÓN" = solo cerrar modal
   ✅ iOS SAFE: NO document touchmove preventDefault (mata scroll)
   ========================================================= */

(function () {
  if (window.__BBX_PDP_MEDIA_MODAL_FAST__) return;
  window.__BBX_PDP_MEDIA_MODAL_FAST__ = true;

  // ===== DEDUPE =====
  var modalNodes = document.querySelectorAll("#bbx-pdp-media-modal");
  if (!modalNodes || !modalNodes.length) return;
  for (var i = 1; i < modalNodes.length; i++) {
    try { modalNodes[i].remove(); } catch(e){}
  }
  var modal = modalNodes[0];

  // ===== PORTAL =====
  var portal = document.getElementById("bbx-modal-portal");
  if (!portal) {
    portal = document.createElement("div");
    portal.id = "bbx-modal-portal";
    document.body.appendChild(portal);
  }
  if (modal.parentElement !== portal) portal.appendChild(modal);

  // ===== REFS =====
  var btnClose  = modal.querySelector("[data-bbx-pdp-modal-close]");
  var btnPrev   = modal.querySelector("[data-bbx-pdp-modal-prev]");
  var btnNext   = modal.querySelector("[data-bbx-pdp-modal-next]");
  var btnDesc   = modal.querySelector("[data-bbx-pdp-modal-desc]");
  var btnAtc    = modal.querySelector("[data-bbx-pdp-modal-atc]");
  var counterEl = modal.querySelector("[data-bbx-pdp-modal-counter]");
  var zoomWrap  = modal.querySelector("[data-bbx-pdp-modal-zoomwrap]");
  var imgEl     = modal.querySelector("[data-bbx-pdp-modal-img]");
  if (!zoomWrap || !imgEl) return;

  var galleryRoot = document.querySelector(".bbx-product-khy__media");
  if (!galleryRoot) return;

  var galleryImgs = Array.from(
    galleryRoot.querySelectorAll(".bbx-product-khy__media-track .bbx-product-khy__img, .bbx-product-khy__img")
  ).filter(Boolean);

  var images = galleryImgs.map(function(img){
    return {
      src: img.currentSrc || img.getAttribute("src") || img.getAttribute("data-src"),
      alt: img.getAttribute("alt") || ""
    };
  }).filter(function(x){ return !!x.src; });

  if (!images.length) return;

  // ===== STATE =====
  var index = 0;

  var scale = 1, tx = 0, ty = 0;
  var pointers = new Map();
  var lastTap = 0;
  var isPanning = false;
  var panStart = { x: 0, y: 0, tx: 0, ty: 0 };
  var swipeStart = { x: 0, y: 0, time: 0 };
  var pinchStartDist = 0;
  var pinchStartScale = 1;

  var isLocked = false;

  // ===== iOS SAFE LOCK (NO touchmove preventDefault) =====
  function lock(on){
    if (on && isLocked) return;
    if (!on && !isLocked) return;

    if (on) {
      isLocked = true;
      try { document.documentElement.classList.add("bbx-pdp-modal-open"); } catch(e){}
      try { document.documentElement.style.overflow = "hidden"; } catch(e){}
      try { document.body.style.overflow = "hidden"; } catch(e){}
    } else {
      isLocked = false;
      try { document.documentElement.classList.remove("bbx-pdp-modal-open"); } catch(e){}
      try { document.documentElement.style.overflow = ""; } catch(e){}
      try { document.body.style.overflow = ""; } catch(e){}
    }
  }

  // ===== HARD UNLOCK (por si algo externo deja lock pegado) =====
  function hardUnlock(){
    try { document.documentElement.classList.remove("bbx-pdp-modal-open"); } catch(e){}
    try { document.documentElement.style.overflow = ""; } catch(e){}
    try { document.body.style.overflow = ""; } catch(e){}
    try {
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.body.style.width = "";
    } catch(e){}

    try {
      if (zoomWrap && zoomWrap.releasePointerCapture && pointers && pointers.size) {
        pointers.forEach(function(_, pid){
          try { zoomWrap.releasePointerCapture(pid); } catch(e){}
        });
      }
    } catch(e){}

    try { pointers && pointers.clear && pointers.clear(); } catch(e){}
    isLocked = false;

    // micro repaint iOS
    setTimeout(function(){
      try { document.documentElement.style.overflow = ""; } catch(e){}
      try { document.body.style.overflow = ""; } catch(e){}
    }, 0);
  }

  // ===== TRANSFORM =====
  function applyTransform(){
    imgEl.style.transform = "translate3d(" + tx + "px," + ty + "px,0) scale(" + scale + ")";
  }

  function resetZoom(){
    scale = 1; tx = 0; ty = 0;
    applyTransform();
  }

  function clampPan(){
    var max = 260 * (scale - 1);
    tx = Math.max(-max, Math.min(max, tx));
    ty = Math.max(-max, Math.min(max, ty));
  }

  function render(){
    var item = images[index];
    imgEl.src = item.src;
    imgEl.alt = item.alt || "";
    if (counterEl) counterEl.textContent = (index + 1) + "/" + images.length;
    resetZoom();
  }

  // ===== OPEN/CLOSE =====
  function openAt(i){
    index = Math.max(0, Math.min(images.length - 1, i));
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden","false");
    lock(true);
    render();
  }

  function close(){
    // blur active element
    try {
      var ae = document.activeElement;
      if (ae && modal.contains(ae) && ae.blur) ae.blur();
    } catch(e){}

    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden","true");

    // IMPORTANT: unlock on next frame (iOS gesture-safe)
    requestAnimationFrame(function(){
      lock(false);
      hardUnlock();
    });

    resetZoom();
    try { pointers.clear(); } catch(e){}
    isPanning = false;
  }

  function next(){ index = (index + 1) % images.length; render(); }
  function prev(){ index = (index - 1 + images.length) % images.length; render(); }

  function dist(a,b){
    var dx = a.x - b.x, dy = a.y - b.y;
    return Math.hypot(dx,dy);
  }

  // ===== PDP CLICK OPEN =====
  galleryRoot.addEventListener("click", function(e){
    var img = e.target.closest(".bbx-product-khy__img");
    if (!img) return;
    var ii = galleryImgs.indexOf(img);
    openAt(ii >= 0 ? ii : 0);
  });

  // ===== PDP SWIPE OPEN NEXT/PREV =====
  (function(){
    var startX=0, startY=0, startT=0, dxFinal=0, moved=false;

    function getActiveIndex(){
      var active = galleryRoot.querySelector(".bbx-product-khy__slide.is-active");
      if (active) {
        var idx = parseInt(active.getAttribute("data-index") || "0", 10);
        if (!isNaN(idx)) return idx;
      }
      return 0;
    }
    function clamp(i){ return Math.max(0, Math.min(images.length - 1, i)); }

    galleryRoot.addEventListener("touchstart", function(e){
      if (!e.touches || !e.touches[0]) return;
      var t = e.touches[0];
      startX = t.clientX; startY = t.clientY; startT = Date.now();
      dxFinal = 0; moved = false;
      galleryRoot.__bbxStartIdx = getActiveIndex();
    }, { passive:true });

    galleryRoot.addEventListener("touchmove", function(e){
      if (!e.touches || !e.touches[0]) return;
      var t = e.touches[0];
      var dx = t.clientX - startX;
      var dy = t.clientY - startY;
      dxFinal = dx;
      if (Math.abs(dx) > 26 && Math.abs(dy) < 35) moved = true;
    }, { passive:true });

    galleryRoot.addEventListener("touchend", function(){
      if (!moved) return;
      var dt = Date.now() - startT;
      if (dt > 700) return;
      var startIdx = Number(galleryRoot.__bbxStartIdx || 0);
      var dir = dxFinal < 0 ? +1 : -1;
      var openIdx = clamp(startIdx + dir);
      setTimeout(function(){ openAt(openIdx); }, 40);
    }, { passive:true });
  })();

  // ===== BUTTONS =====
  if (btnClose) btnClose.addEventListener("click", function(e){
    e.preventDefault(); e.stopPropagation();
    close();
  });

  if (btnNext) btnNext.addEventListener("click", function(e){ e.preventDefault(); e.stopPropagation(); next(); });
  if (btnPrev) btnPrev.addEventListener("click", function(e){ e.preventDefault(); e.stopPropagation(); prev(); });

  // ✅ VER DESCRIPCIÓN = SOLO CERRAR (NADA MÁS)
  if (btnDesc) {
    btnDesc.addEventListener("click", function(e){
      e.preventDefault(); e.stopPropagation();
      try { e.stopImmediatePropagation(); } catch(_){}
      close();
    }, true);
  }

  // ESC / arrows
  document.addEventListener("keydown", function(e){
    if (!modal.classList.contains("is-open")) return;
    if (e.key === "Escape") { close(); return; }
    if (window.matchMedia("(min-width: 768px)").matches && images.length > 1) {
      if (e.key === "ArrowRight") next();
      if (e.key === "ArrowLeft") prev();
    }
  }, true);

  // ATC
  if (btnAtc) btnAtc.addEventListener("click", function(e){
    e.preventDefault(); e.stopPropagation();
    var realAtc = document.querySelector('[data-bbx-add-cart="icon"]');
    if (realAtc) realAtc.click();
    close();

    setTimeout(function(){
      var trigger = document.querySelector("[data-bbx-cart-open]");
      if (trigger) trigger.click();
      else document.documentElement.dispatchEvent(new CustomEvent("bbx:open-cart"));
    }, 140);
  });

  // ===== GESTURES INSIDE MODAL =====
  zoomWrap.addEventListener("pointerdown", function(e){
    try { zoomWrap.setPointerCapture(e.pointerId); } catch(_){}
    pointers.set(e.pointerId, { x:e.clientX, y:e.clientY });

    if (pointers.size === 1) {
      swipeStart = { x:e.clientX, y:e.clientY, time:Date.now() };
      if (scale > 1) {
        isPanning = true;
        panStart = { x:e.clientX, y:e.clientY, tx:tx, ty:ty };
      }
    }

    if (pointers.size === 2) {
      var pts = Array.from(pointers.values());
      pinchStartDist = dist(pts[0], pts[1]);
      pinchStartScale = scale;
      isPanning = false;
    }
  });

  zoomWrap.addEventListener("pointermove", function(e){
    if (!pointers.has(e.pointerId)) return;
    pointers.set(e.pointerId, { x:e.clientX, y:e.clientY });

    if (pointers.size === 2) {
      var pts = Array.from(pointers.values());
      var d = dist(pts[0], pts[1]) || pinchStartDist || 1;
      var raw = d / (pinchStartDist || d);
      scale = Math.max(1, Math.min(4, pinchStartScale * raw));
      clampPan();
      applyTransform();
      return;
    }

    if (isPanning && pointers.size === 1 && scale > 1) {
      var dx = e.clientX - panStart.x;
      var dy = e.clientY - panStart.y;
      tx = panStart.tx + dx;
      ty = panStart.ty + dy;
      clampPan();
      applyTransform();
    }
  });

  zoomWrap.addEventListener("pointerup", function(e){
    pointers.delete(e.pointerId);

    if (pointers.size === 1 && scale > 1) {
      var pt = Array.from(pointers.values())[0];
      isPanning = true;
      panStart = { x:pt.x, y:pt.y, tx:tx, ty:ty };
    } else {
      isPanning = false;
    }

    if (scale === 1 && images.length > 1) {
      var dx = e.clientX - swipeStart.x;
      var dy = e.clientY - swipeStart.y;
      var dt = Date.now() - swipeStart.time;
      if (dt < 420 && Math.abs(dx) > 40 && Math.abs(dy) < 50) {
        if (dx < 0) next(); else prev();
      }
    }
  });

  zoomWrap.addEventListener("click", function(){
    var now = Date.now();
    if (now - lastTap < 280) {
      if (scale > 1) resetZoom();
      else { scale = 2.6; tx = 0; ty = 0; applyTransform(); }
      lastTap = 0;
      return;
    }
    lastTap = now;
  });

  // EXTRA: si por lo que sea se queda lock pegado y el modal NO esta abierto, un tap lo destraba
  document.addEventListener("touchstart", function(){
    if (!modal.classList.contains("is-open")) hardUnlock();
  }, { passive:true });

})();
